document.documentElement.classList.add("preloader-active");

document.addEventListener("DOMContentLoaded", function() {

  /* -----------------------------
     1. Universal UL Splitter
  ----------------------------- */
  function splitList(selector, splitIndex = 5, newClass = "second-ul") {
    const $originalUL = $(selector);

    if ($originalUL.length) {
      const $items = $originalUL.children("li");

      // No split if not enough items
      if ($items.length <= splitIndex) return null;

      const originalClasses = $originalUL.attr("class") || "";

      const $newUL = $(
        `<ul role="list" class="${originalClasses} ${newClass}"></ul>`
      );

      $items.slice(splitIndex).appendTo($newUL);

      $newUL.insertAfter($originalUL);

      return $newUL;
    }

    return null;
  }

  // Header
  const $secondHeaderUL = splitList(".hdr-nav-primary-level-ul", 6, "second-ul");

  // Footer
  // splitList(".footer-block-linklist-ul ul", 3, "footer-second-ul");

  /* -----------------------------
    1.1 Insert Logo Between Split ULs
        OR Before Main UL if No Split
        (All Pages EXCEPT Homepage)
        + Hide Original ONLY on Desktop
  ----------------------------- */
  if (window.location.pathname !== "/") {

    const $logoBlock = $(
      "#SiteHeaderInner .header-bar--left.header-bar--left-logo-mobile.header-bar--left-logo"
    );

    if ($logoBlock.length) {
      const $clone = $logoBlock.clone(true, true);

      if ($secondHeaderUL) {
        // Case 1: split happened → insert between ULs
        $clone.insertBefore($secondHeaderUL);
      } else {
        // Case 2: split did NOT happen → insert before main UL
        const $mainUL = $(".hdr-nav-primary-level-ul").first();

        if ($mainUL.length) {
          $clone.insertBefore($mainUL);
        }
      }

      // Remove original on desktop only
      if (window.innerWidth > 1025) {
        $logoBlock.remove();
      }
    }
  }





  /* -----------------------------
     2. Loader Fade Out
     ----------------------------- */
  const APP_STABILIZATION_DELAY = 600;

  setTimeout(() => {
    const loader = document.getElementById("site-preloader");
    if (!loader) return;

    loader.style.opacity = "0";
    loader.style.transition = "opacity 400ms ease";

    setTimeout(() => {
      loader.style.display = "none";
      document.documentElement.classList.remove("preloader-active");
    }, 400);
  }, APP_STABILIZATION_DELAY);



  /* -----------------------------
     3. GSAP Parallax Media Sections
     ----------------------------- */
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);

    /* VIDEO Parallax */
    const videoWrappers = document.querySelectorAll(".video-parallax-wrapper");

    videoWrappers.forEach(wrapper => {
      const video = wrapper.querySelector("video");
      if (!video) return;

      video.style.height = "160%";
      video.style.willChange = "transform";

      gsap.fromTo(
        video,
        { y: "-40%" },
        {
          y: "40%",
          ease: "none",
          scrollTrigger: {
            trigger: wrapper,
            start: "top bottom",
            end: "bottom top",
            scrub: 1.6,
          }
        }
      );
    });
  }



  /* -----------------------------
   4. Match Product Info Height (Desktop Only)
   ----------------------------- */
function matchProductHeights() {
  const source = document.querySelector(".product-main-top-section");
  const target = document.querySelector(".product.product-main-info-section");

  if (!source || !target) return;

  // Desktop only
  if (window.innerWidth > 1025) {
    const height = source.offsetHeight / 2;
    target.style.height = height + "px";
  } else {
    // Reset on mobile
    target.style.height = "";
  }
}

// Run once + on resize
matchProductHeights();
window.addEventListener("resize", matchProductHeights);


});


/* ---------- Scroll reveal: homepage ---------- */
window.addEventListener("load", function () {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  gsap.registerPlugin(ScrollTrigger);

  var scope = ".template-index main .shopify-section:not(:first-child):not([id*='luxury_simple'])";

  gsap.utils.toArray(scope + " h2, " + scope + " .rte p").forEach(function (el) {
    gsap.from(el, {
      y: 24, opacity: 0, duration: 1.1, ease: "power3.out",
      scrollTrigger: { trigger: el, start: "top 88%", once: true }
    });
  });

  gsap.utils.toArray(scope + " img").forEach(function (img) {
    gsap.from(img, {
      y: 30, opacity: 0, duration: 1.3, delay: 0.1, ease: "power3.out",
      scrollTrigger: { trigger: img, start: "top 92%", once: true }
    });
  });

  ScrollTrigger.refresh();
});

/* HAIR COLOR CHART: light to dark */
(function () {
  var ORDER = ['Bees Knees','Gin + Tonic','Whiskey Sour','Prosecco','Mint Julep','Margarita','Caipirinha','Pina Colada','Vesper Martini','Dirty Martini','Twisted Mai Tai','Mai Tai','Peach Bellini','Sidecar','Negroni','Tequila Sunrise','Aperol Spritz','Light N Stormy','Dark N Stormy','High Ball','Cuba Libre','New Fashioned','Old Fashioned','Manhattan','Vieux Carre','Merlot','Espresso Martini','Black Magic'];
  function key(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[^a-z0-9]/g, ''); }
  var rank = {};
  ORDER.forEach(function (n, i) { rank[key(n)] = i; });
  function run() {
    var grids = Array.prototype.slice.call(document.querySelectorAll('[class*="ai-hair-color-chart__grid-"]'));
    if (!grids.length) return;
    var items = [];
    grids.forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (el) {
        if (/ai-hair-color-chart__item-/.test(el.className)) items.push(el);
      });
    });
    function r(el) {
      var t = el.querySelector('[class*="ai-hair-color-chart__title-"]');
      var k = key(t && t.textContent);
      return k in rank ? rank[k] : 999;
    }
    items.sort(function (a, b) { return r(a) - r(b); });
    items.forEach(function (el) { grids[0].appendChild(el); });
    grids.slice(1).forEach(function (g) {
      if (!g.children.length) {
        if (g.parentElement) g.parentElement.style.display = 'none';
        var sec = g.closest('.shopify-section');
        if (sec && sec.textContent.trim() === '') sec.style.display = 'none';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Product row: arrows + drag */
(function () {
  function init(sec) {
    var track = sec.querySelector('.ahpr__track');
    if (!track || sec.querySelector('.ahpr__arrow')) return;

    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.className = 'ahpr__arrow ahpr__arrow--prev';
    next.className = 'ahpr__arrow ahpr__arrow--next';
    prev.setAttribute('aria-label', 'Previous');
    next.setAttribute('aria-label', 'Next');
    prev.innerHTML = '&#8592;';
    next.innerHTML = '&#8594;';
    sec.appendChild(prev);
    sec.appendChild(next);

    function step() {
      var card = track.querySelector('.ahpr__card');
      return card ? card.offsetWidth + 8 : track.clientWidth * 0.8;
    }
    function update() {
      prev.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('mousedown', function (e) {
      down = true; moved = false;
      startX = e.pageX; startLeft = track.scrollLeft;
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); moved = false; }
    }, true);
  }

  function run() { document.querySelectorAll('.ahpr').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Screenshot mode: add ?clean=1 to any URL to hide the chat bubble, ?clean=0 to bring it back */
(function () {
  try {
    var q = location.search;
    if (/[?&]clean=1/.test(q)) sessionStorage.setItem('ahClean', '1');
    if (/[?&]clean=0/.test(q)) sessionStorage.removeItem('ahClean');
    if (sessionStorage.getItem('ahClean')) document.documentElement.classList.add('ah-clean');
  } catch (e) {}
})();
/* ===== AH MOTION ===== */
(function () {
  if (window.__ahMotion) return;
  window.__ahMotion = true;

  /* Logo: where the divider line sits, as a share of the logo width.
     Nudge these if the line animation lands off the line. */
  var LOGO_LINE_START = 0.66;
  var LOGO_LINE_END = 0.71;
  var LOGO_LETTERS = 8;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- LOGO ---------- */
  function findLogo(header) {
    return header.querySelector('[class*="logo"] a[href], a[href][class*="logo"]') ||
      header.querySelector('a[href="/"], a[href="' + location.origin + '/"]');
  }

  function logoIntro(link) {
    var media = link.querySelector('img, svg');

    if (!media) {
      var text = link.textContent.trim();
      if (!text || link.children.length) return;
      var html = '';
      text.split('').forEach(function (ch, i) {
        html += ch === ' ' ? ' ' : '<span class="ah-logo-text-mask"><span class="ah-logo-text-ch" style="animation-delay:' + (i * 45) + 'ms">' + ch + '</span></span>';
      });
      link.innerHTML = html;
      setTimeout(function () { link.textContent = text; }, 2000);
      return;
    }

    function run() {
      var mb = media.getBoundingClientRect();
      var lb = link.getBoundingClientRect();
      if (!mb.width || !mb.height) return;
      if (getComputedStyle(link).position === 'static') link.style.position = 'relative';

      var wrap = document.createElement('span');
      wrap.className = 'ah-logo-anim';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.cssText = 'left:' + (mb.left - lb.left) + 'px;top:' + (mb.top - lb.top) + 'px;width:' + mb.width + 'px;height:' + mb.height + 'px';

      function part(cls, left, right, delay) {
        var outer = document.createElement('span');
        outer.className = cls;
        outer.style.clipPath = 'inset(0 ' + (right * 100) + '% 0 ' + (left * 100) + '%)';
        var c = media.cloneNode(true);
        c.removeAttribute('id');
        c.removeAttribute('loading');
        c.style.animationDelay = delay + 'ms';
        outer.appendChild(c);
        wrap.appendChild(outer);
      }

      var step = LOGO_LINE_START / LOGO_LETTERS;
      for (var k = 0; k < LOGO_LETTERS; k++) {
        part('ah-lg-letter', k * step, 1 - (k + 1) * step, 80 + k * 55);
      }
      var lineAt = 80 + LOGO_LETTERS * 55 + 250;
      part('ah-lg-line', LOGO_LINE_START, 1 - LOGO_LINE_END, lineAt);
      part('ah-lg-word', LOGO_LINE_END, 0, lineAt + 450);

      media.style.visibility = 'hidden';
      link.appendChild(wrap);
      setTimeout(function () {
        media.style.visibility = '';
        wrap.remove();
      }, lineAt + 1400);
    }

    if (media.tagName === 'IMG' && !media.complete) media.addEventListener('load', run, { once: true });
    else run();
  }

  function headerShrink(header, link) {
    link.classList.add('ah-logo-link');
    if (getComputedStyle(link).display === 'inline') link.style.display = 'inline-block';
    var lb = link.getBoundingClientRect();
    var mid = lb.left + lb.width / 2;
    var center = Math.abs(mid - window.innerWidth / 2) < window.innerWidth * 0.15;
    link.style.setProperty('--ah-logo-origin', center ? 'center center' : 'left center');

    var tight = false;
    function check() {
      var t = window.scrollY > 60;
      if (t !== tight) { tight = t; header.classList.toggle('ah-tight', t); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  (function initLogo() {
    var header = document.getElementById('SiteHeader');
    if (!header) { ready(function () { if (document.getElementById('SiteHeader')) initLogo(); }); return; }
    var link = findLogo(header);
    if (!link) return;
    headerShrink(header, link);
    var played = false;
    try { played = !!sessionStorage.getItem('ahLogoPlayed'); sessionStorage.setItem('ahLogoPlayed', '1'); } catch (e) {}
  })();

  /* ---------- SCROLL REVEALS ---------- */
  var HEADINGS = [
    'main h1', 'main h2', 'main .h1', 'main .h2',
    '.ahpr__title', '.ahmt__title', '.ahrt__title', '.ahbd__heading', '.ahst__title', '.ahmi h1', '.ahmi h2'
  ].join(',');
  var IMAGES = '.ahpr__card img, .ahmt img, .ahrt__media img, .ahmi img, .ahst img';
  var SKIP = '.ahm, #SiteHeader, .ahn, .ahf, [data-ah-no-motion]';

  function splitLines(h) {
    if (h.dataset.ahText == null) h.dataset.ahText = h.innerHTML;
    var text = h.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return false;
    h.innerHTML = text.split(' ').map(function (w) { return '<span class="ah-w" style="display:inline-block">' + w + '</span>'; }).join(' ');
    var lines = [], top = null;
    h.querySelectorAll('.ah-w').forEach(function (w) {
      if (top === null || Math.abs(w.offsetTop - top) > 4) { lines.push([]); top = w.offsetTop; }
      lines[lines.length - 1].push(w.textContent);
    });
    h.innerHTML = lines.map(function (l, i) {
      return '<span class="ah-line"><span class="ah-line__in" style="--d:' + (i * 110) + 'ms">' + l.join(' ') + '</span></span>';
    }).join('');
    return lines.length;
  }

  function restore(h) {
    if (h.dataset.ahText != null) h.innerHTML = h.dataset.ahText;
    h.removeAttribute('data-ah-text');
  }

  function initReveals() {
    if (reduce || editor || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target.__ahImg || e.target;
        io.unobserve(e.target);
        if (el.classList.contains('ah-wipe')) el.style.setProperty('--d', (n++ * 90) + 'ms');
        el.classList.add('ah-in');
        if (el.__ahLines) {
          setTimeout(function () { restore(el); el.classList.remove('ah-in'); el.__ahLines = 0; }, 1100 + el.__ahLines * 110);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    var heads = [];
    document.querySelectorAll(HEADINGS).forEach(function (h) {
      if (h.closest(SKIP) || h.__ahSeen) return;
      if (h.querySelector('img, svg, input, button')) return;
      h.__ahSeen = true;
      heads.push(h);
    });
    heads.forEach(function (h) {
      var n = splitLines(h);
      if (n) { h.__ahLines = n; io.observe(h); }
    });

    document.querySelectorAll(IMAGES).forEach(function (img) {
      if (img.closest(SKIP) || img.__ahSeen) return;
      img.__ahSeen = true;
      img.classList.add('ah-wipe');
      var box = img.parentElement;
      box.__ahImg = img;
      io.observe(box);
    });

    var rw = window.innerWidth, t;
    window.addEventListener('resize', function () {
      if (window.innerWidth === rw) return;
      rw = window.innerWidth;
      clearTimeout(t);
      t = setTimeout(function () {
        heads.forEach(function (h) {
          if (h.__ahLines && !h.classList.contains('ah-in')) { restore(h); h.__ahLines = splitLines(h); }
        });
      }, 200);
    });
  }

  /* ---------- CURSOR ---------- */
  function initCursor() {
    if (!fine || editor) return;

    var dot = document.createElement('div');
    dot.className = 'ah-cursor';
    dot.innerHTML = '<span></span>';
    var tag = document.createElement('div');
    tag.className = 'ah-cursor-label';
    tag.innerHTML = '<span></span>';
    var tagText = tag.firstChild;
    document.body.appendChild(dot);
    document.body.appendChild(tag);
    document.documentElement.classList.add('ah-cursor-on');

    var x = -100, y = -100, cx = x, cy = y, shown = false;
    function setState(state, label) {
      dot.classList.toggle('is-link', state === 'link');
      dot.classList.toggle('is-label', state === 'label');
      dot.classList.toggle('is-text', state === 'text');
      tag.classList.toggle('is-label', state === 'label');
      if (label) tagText.textContent = label;
    }

    function resolve(t) {
      if (!t || !t.closest) return setState('none');
      if (t.closest('input, textarea, select, [contenteditable], iframe')) return setState('text');
      if (t.closest('.ahpr__track')) return setState('label', 'Drag');
      if (t.closest('.ahm') && !t.closest('a, button, .ahm__glass')) return setState('label', 'Next');
      if (t.closest('.ahrt__card, .ahmt__card, a[href*="/products/"]')) return setState('label', 'Shop');
      if (t.closest('a[href], button, [role="button"], summary, label')) return setState('link');
      setState('none');
    }

    document.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!shown) { shown = true; cx = x; cy = y; dot.classList.add('is-on'); tag.classList.add('is-on'); }
    }, { passive: true });
    document.addEventListener('mouseover', function (e) { resolve(e.target); }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget) { shown = false; dot.classList.remove('is-on'); tag.classList.remove('is-on'); }
    });
    document.addEventListener('mousedown', function () { dot.classList.add('is-down'); tag.classList.add('is-down'); });
    document.addEventListener('mouseup', function () { dot.classList.remove('is-down'); tag.classList.remove('is-down'); });

    (function loop() {
      var k = reduce ? 1 : 0.22;
      cx += (x - cx) * k; cy += (y - cy) * k;
      dot.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      tag.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)';
      requestAnimationFrame(loop);
    })();

    /* Click anywhere on the hero (outside its buttons and cards) to go to the next one */
    document.querySelectorAll('.ahm').forEach(function (hero) {
      hero.addEventListener('click', function (e) {
        if (e.target.closest('a, button, input, .ahm__glass, [data-lenis-prevent]')) return;
        var next = hero.querySelector('[data-ahm-next]');
        if (next) next.click();
      });
    });
  }

  ready(function () {
    initCursor();
    var go = function () { initReveals(); };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go();
  });
})();
/* ===== END AH MOTION ===== */

/* ===== AH INTRO + FOOTER LOGO ===== */
(function () {
  if (window.__ahIntro) return;
  window.__ahIntro = true;
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);

  /* Images to flick through: product photos already on the page */
  var STACK_FROM = '.ahpr__media img, .ahmt img, .ahrt__media img, .ahmi img';
  var STACK_MAX = 14;
  var FLICK_MS = 110;
  var MIN_MS = 2400;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function findLogo() {
    return document.querySelector('.ahf__logo svg, .ahf__logo img') ||
      document.querySelector('#SiteHeader [class*="logo"] img, #SiteHeader [class*="logo"] svg, #SiteHeader a[href="/"] img, #SiteHeader a[href="/"] svg');
  }

  function stackUrls() {
    var seen = {}, out = [];
    document.querySelectorAll(STACK_FROM).forEach(function (img) {
      var u = img.currentSrc || img.getAttribute('src');
      if (!u || seen[u] || out.length >= STACK_MAX) return;
      seen[u] = 1;
      out.push(u);
    });
    return out;
  }

  function intro() {
    if (!root.classList.contains('ah-intro')) return;
    if (editor) { root.classList.remove('ah-intro'); return; }
    try { sessionStorage.setItem('ahIntro', '1'); } catch (e) {}

    var panel = document.createElement('div');
    panel.className = 'ah-intro-panel';
    panel.setAttribute('aria-hidden', 'true');
    panel.innerHTML = '<div class="ah-intro-stack"></div><div class="ah-intro-mark"><div class="ah-intro-logo"></div></div><div class="ah-intro-count">000</div>';
    var src = findLogo();
    if (src) {
      var c = src.cloneNode(true);
      c.removeAttribute('id');
      c.removeAttribute('loading');
      c.removeAttribute('srcset');
      panel.querySelector('.ah-intro-logo').appendChild(c);
    }
    var stack = panel.querySelector('.ah-intro-stack');
    var count = panel.querySelector('.ah-intro-count');
    document.body.appendChild(panel);
    root.classList.add('ah-intro-ready');
    panel.getBoundingClientRect();
    requestAnimationFrame(function () { panel.classList.add('is-in'); });

    /* preload, then flick through whatever has loaded */
    var loadedImgs = [];
    stackUrls().forEach(function (u) {
      var im = new Image();
      im.onload = function () { loadedImgs.push(u); };
      im.src = u;
    });
    if (!loadedImgs.length && !stackUrls().length) stack.style.display = 'none';
    var shown = document.createElement('img');
    shown.alt = '';
    var k = 0, flick = setInterval(function () {
      if (!loadedImgs.length) return;
      if (!shown.parentNode) stack.appendChild(shown);
      shown.src = loadedImgs[k % loadedImgs.length];
      k++;
    }, FLICK_MS);

    var start = Date.now(), pageLoaded = document.readyState === 'complete', done = false;
    if (!pageLoaded) window.addEventListener('load', function () { pageLoaded = true; }, { once: true });

    function finish() {
      if (done) return;
      done = true;
      clearInterval(flick);
      count.textContent = '100';
      panel.classList.add('is-done');
      setTimeout(function () {
        panel.classList.add('is-out');
        root.classList.remove('ah-intro');
        setTimeout(function () { panel.remove(); root.classList.remove('ah-intro-ready'); }, 1200);
      }, 250);
    }

    (function tick() {
      if (done) return;
      var t = Date.now() - start;
      var pct = Math.min(t / MIN_MS, pageLoaded ? 1 : 0.9);
      var n = Math.floor(pct * 100);
      count.textContent = (n < 10 ? '00' : n < 100 ? '0' : '') + n;
      if (pct >= 1) finish();
      else requestAnimationFrame(tick);
    })();
    setTimeout(finish, 5000);
  }

  function footerRise() {
    if (reduce || editor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('ah-up');
        io.unobserve(e.target);
      });
    }, { threshold: 0.2 });
    document.querySelectorAll('.ahf__logo').forEach(function (l) {
      l.classList.add('ah-rise');
      io.observe(l);
    });
  }

  ready(function () { intro(); footerRise(); });
})();
/* ===== END AH INTRO + FOOTER LOGO ===== */

